import React, { useRef } from "react";
import PropTypes from "prop-types";
import { Modal } from "antd";
import SpendingForm from "./SpendingForm";
import useSpendingUpdate from "../hooks/useSpendingUpdate";

export default function UpdateSpendingModal({ open, onClose, onCompleted, spending, queryOption }) {
  const formRef = useRef(null);

  const [updateSpending, { loading: mutationLoading }] = useSpendingUpdate(queryOption, () => {
    formRef.current.resetFields();
    onClose();

    if (onCompleted) {
      onCompleted();
    }
  });

  return (
    <Modal title="變更消費紀錄" open={open} centered footer={null} onCancel={() => onClose()}>
      <SpendingForm
        key={spending.id}
        ref={formRef}
        initialValues={spending}
        uploading={mutationLoading}
        onSubmit={(value) => {
          updateSpending({
            variables: {
              ...value,
              id: spending.id,
              amount: Number(value.amount),
            },
          });
        }}
      />
    </Modal>
  );
}

UpdateSpendingModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCompleted: PropTypes.func,
  spending: PropTypes.shape({
    id: PropTypes.string.isRequired,
    // dayjs 物件
    date: PropTypes.object.isRequired,
    categoryId: PropTypes.string.isRequired,
    currencyId: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    note: PropTypes.string.isRequired,
  }).isRequired,
  queryOption: PropTypes.shape({
    query: PropTypes.object,
  }).isRequired,
};

UpdateSpendingModal.defaultProps = {
  onCompleted: null,
};
